import { useSearchParams } from './use-search-params';

export function usePdfGeneration(): boolean {
  const { pdfGeneration } = useSearchParams();
  return pdfGeneration();
}
